import React, { useState } from "react";
import toHTML from "../helpers/toHtml";
import styled from "styled-components";
import colors from "../styles/colors";
import Wrapper from "../components/styled/wrapper";
import ToggleButton from "../components/styled/ToggleButton";

import Blob1 from "../img/blob1.svg";
import Blob2 from "../img/blob2.svg";
import Blob3 from "../img/blob3.svg";

export default ({ policies }) => {
  const [expanded, setExpanded] = useState(false);
  return (
    <Policies>
      <PoliciesWrapper expanded={expanded}>
        <Column bg={Blob1} dangerouslySetInnerHTML={{ __html: toHTML(policies.col1) }} />
        <Column bg={Blob2} dangerouslySetInnerHTML={{ __html: toHTML(policies.col2) }} />
        <Column bg={Blob3} dangerouslySetInnerHTML={{ __html: toHTML(policies.col3) }} />
      </PoliciesWrapper>
      {!expanded && (<ToggleButton onClick={() => setExpanded(true)}>Visa mer</ToggleButton>)}
      {expanded && (<ToggleButton onClick={() => setExpanded(false)}>Visa mindre</ToggleButton>)}
    </Policies>
  );
};

const Policies = styled.div`
  padding: 6rem 0;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
`

const PoliciesWrapper = styled(Wrapper)`
  max-height: ${props => props.expanded ? "auto" : "40rem"};
  margin-bottom: ${props => props.expanded ? "0" : "3rem"};
  overflow:hidden;
  position: relative;
  &:after {
    content: "";
    display: ${props => props.expanded ? "none" : "block"};
    position: absolute;
    z-index: 1;
    bottom: 0;
    left: 0;
    pointer-events: none;
    background-image: linear-gradient(to bottom,
                      rgba(255,255,255, 0),
                      rgba(255,255,255, 1) 90%);
    width: 100%;
    height: 10em;
  }

  padding: 6rem 0 0 0;
  display: grid;
  grid-template-columns: 1fr;
  grid-gap: 2rem;
  max-width: 80rem;
  background-image: url(${Blob1}), url(${Blob2}), url(${Blob3});
  background-position: center center, -10% center, 100% center;
  background-repeat: no-repeat;
  background-size: contain;

  @media (max-width: 1200px) {
    background-image: url(${Blob1}), url(${Blob2});
    background-position: 10% center, 90% center;
  }
  @media (max-width: 800px) {
    background-image: none;
  }

  @media (min-width: 700px) {
    grid-template-columns: 1fr 1fr 1fr;
    grid-gap: 5rem;
  }
`

const Column = styled.div`
  /* background-image: url(${props => props.bg});
  background-position: center center;
  background-repeat: no-repeat;
  background-size: 150%; */
`